export default __webpack_public_path__ + "images/XM.8e5c9a6.png";